import request from '@/utils/request';

// 天目登录
export function tmLogin(data) {
  return request({
    url: '/wap/app/login',
    method: 'post',
    data: data
  });
}

// 天目登录
export function getLoginUserDetail(data) {
  return request({
    url: '/wap/api/login_v2',
    method: 'post',
    data: data
  });
}
